import { swRequest } from "@sourcewhale/shared/src/svelte/api/sw-request";

export const requestAccess = (feature, adminsSettings) =>
  // NB: feature should be the feature name, e.g. "Dialer" not "dialler"
  swRequest({
    path: "/api/features/request_access",
    method: "POST",
    body: { feature, adminsSettings },
  });
